import { tx } from "@/i18n/tx";
import { useState } from "react";
import { api, fmtCHF, fmtDate, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import Sheet from "@/components/invoices/Sheet";

const COPY = {
  unpay: { title: tx("ui_invoiceactionsheet.k8d9694"), cta: tx("ui_invoiceactionsheet.k8d9694"), ok: tx("ui_invoiceactionsheet.ke06482") },
  cancel: { title: tx("ui_invoiceactionsheet.kb118c2"), cta: tx("ui_invoiceactionsheet.kb118c2"), ok: tx("ui_invoiceactionsheet.k935c94") },
};

// Reverse a payment or cancel an invoice — reason is mandatory and kept in the history.
export default function InvoiceActionSheet({ action, onClose, onDone }) {
  const { type, inv } = action;
  const c = COPY[type];
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post(`/invoices/${inv.id}/${type}`, { reason: reason.trim() });
      toast.success(c.ok);
      onDone();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
      setBusy(false);
    }
  };

  return (
    <Sheet
      title={c.title}
      testId={`invoice-${type}-sheet`}
      onClose={onClose}
      footer={
        <button form="invoice-action-form" disabled={busy || reason.trim().length < 3}
          data-testid={`invoice-${type}-confirm`} className="w-full py-3 rounded-xl bg-red-600 text-white font-semibold disabled:opacity-50">
          {busy ? "…" : c.cta}
        </button>
      }
    >
      <form id="invoice-action-form" onSubmit={submit} className="space-y-3">
        <div className="p-3 rounded-xl bg-surface-muted text-sm">
          <p className="font-semibold">{inv.supplier}{inv.invoice_number ? ` · n° ${inv.invoice_number}` : ""}</p>
          <p className="text-text-secondary text-xs mt-0.5">{fmtCHF(inv.amount)} · {tx("tpl.due", { date: fmtDate(inv.due_date) })}{inv.paid_date ? ` · ${tx("tpl.paid_on", { date: fmtDate(inv.paid_date) })}` : ""}</p>
        </div>
        {(
          <label className="block">
            <span className="text-sm font-medium text-text-secondary block mb-1">{tx("ui_invoiceactionsheet.k336f7b")}</span>
            <textarea required minLength={3} maxLength={300} rows={3} value={reason} onChange={(e) => setReason(e.target.value)} className="input-c" data-testid={`invoice-${type}-reason`}
              placeholder={type === "cancel" ? tx("tpl.ph_cancel") : tx("tpl.ph_unpay")} />
            {type === "cancel" && <span className="text-[11px] text-text-secondary mt-1 block">{tx("ui_invoiceactionsheet.k1e2689")}</span>}
          </label>
        )}
      </form>
    </Sheet>
  );
}
